import React, {useEffect, useState} from 'react'
import {useManagePostRequest} from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import {useManageGetRequest} from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import {
    aprobarCondicionAPI,
    generarPDFParaCrearDocumentoFlujoEmpleadoAPI,
} from "../../../../consumers/backendApisUrls";
import {
 isNullOrUndefinded,
} from "../../../../helper/utils";
import {Div} from "../../../registroMaternidad/modales/components/Components";
import InputTextArea from "../../../../components/modalComponents/InputTextArea";
import InputText from "../../../../components/modalComponents/InputText";
import InputDate from "../../../../components/modalComponents/InputDate";
import InputUploadFile from "../../../../components/modalComponents/InputUploadFile";
import {
    useGenerarDescargarEliminarArchivo
} from "../../../../hooks/useGenerarDescargarEliminarArchivo/useGenerarDescargarEliminarArchivo";
import {UploadFileStyleDiv} from "../../components/StyledComponents";
import ObservarLicencia from "../../../registroMaternidad/modales/Licencias/ObservarLicencia";
import ObservarFlujoDocumentoEmpleado from "./ObservarFlujoDocumentoEmpleado";
import ModalEnabled from "../../../../components/modalComponents/ModalEnabled";

const FlujoDocumentoEmpleado = ({
                   SECTION_NAME,
                   KEYS,
                    row,
                    formValues, setFormValues, setDisableSubmitButton, modalDataToCreate, modalDataAlreadyCreated,
                    handleEnviar, handleAprobar,toggleMainModal, setModalEnabled, fromAdminPage
               }) => {
    const [executeManagePost] = useManagePostRequest();
    const [executeMangGet] = useManageGetRequest();


    const [descargandoArchivo, setDescargandoArchivo] = useState(false);

    const [generarYDescargarArchivo] = useGenerarDescargarEliminarArchivo();

    const descargar = async (e, row) => {
        e.preventDefault();
        setDescargandoArchivo(true);

        if (modalDataToCreate?.DocumentoGenericoUrl)
            window.open(modalDataToCreate?.DocumentoGenericoUrl, '_blank');
        else {
            const payload = {}
            await generarYDescargarArchivo(generarPDFParaCrearDocumentoFlujoEmpleadoAPI(row.IdFlujoDocumentoEmpleado), payload);
        }

        setDescargandoArchivo(false);
    }

    return (
        <>
            <Div col={12}>
                <p style={{fontWeight: 600}} className="mb-0">Información del proceso</p>
            </Div>
            <Div col={12}>
                <hr className="mt-0"/>
            </Div>

            {!isNullOrUndefinded(modalDataAlreadyCreated[KEYS.Responsable]) &&
                modalDataAlreadyCreated[KEYS.Responsable] !== "" &&
                <Div col={6}>
                    <InputText
                        label={"Responsable"}
                        name={"Responsable"}
                        value={modalDataAlreadyCreated[KEYS.Responsable]}
                        sectionName={SECTION_NAME}
                        direction="column"
                        isDisabled={true}
                    />
                </Div>
            }

            {!isNullOrUndefinded(modalDataAlreadyCreated[KEYS.Paso]) &&
                modalDataAlreadyCreated[KEYS.Paso] !== "" &&
                <Div col={3}>
                    <InputText
                        label={"Paso"}
                        name={"Paso"}
                        value={modalDataAlreadyCreated[KEYS.Paso]}
                        sectionName={SECTION_NAME}
                        direction="column"
                        isDisabled={true}
                    />
                </Div>
            }

            {!isNullOrUndefinded(modalDataAlreadyCreated[KEYS.EstadoPaso]) &&
                modalDataAlreadyCreated[KEYS.EstadoPaso] !== "" &&
                <Div col={3}>
                    <InputText
                        label={"Estado"}
                        name={"EstadoPaso"}
                        value={modalDataAlreadyCreated[KEYS.EstadoPaso]}
                        sectionName={SECTION_NAME}
                        direction="column"
                        isDisabled={true}
                    />
                </Div>
            }


            <Div col={12}>
                <p style={{fontWeight: 600}} className="mb-0">Información del empleado</p>
            </Div>
            <Div col={12}>
                <hr className="mt-0"/>
            </Div>

            {!isNullOrUndefinded(modalDataAlreadyCreated[KEYS.Empleado]) &&
                modalDataAlreadyCreated[KEYS.Empleado] !== "" &&
                <Div col={6}>
                    <InputText
                        label={"Empleado"}
                        name={"Empleado"}
                        value={modalDataAlreadyCreated[KEYS.Empleado]}
                        sectionName={SECTION_NAME}
                        direction="column"
                        isDisabled={true}
                    />
                </Div>
            }

            {!isNullOrUndefinded(modalDataAlreadyCreated[KEYS.Cargo]) &&
                modalDataAlreadyCreated[KEYS.Cargo] !== "" &&
                <Div col={6}>
                    <InputText
                        label={"Cargo"}
                        name={"Cargo"}
                        value={modalDataAlreadyCreated[KEYS.Cargo]}
                        sectionName={SECTION_NAME}
                        direction="column"
                        isDisabled={true}
                    />
                </Div>
            }

            {!isNullOrUndefinded(modalDataAlreadyCreated[KEYS.Sede]) &&
                modalDataAlreadyCreated[KEYS.Sede] !== "" &&
                <Div col={6}>
                    <InputText
                        label={"Sede"}
                        name={"Sede"}
                        value={modalDataAlreadyCreated[KEYS.Sede]}
                        sectionName={SECTION_NAME}
                        direction="column"
                        isDisabled={true}
                    />
                </Div>
            }

            <Div col={12}>
                <p style={{fontWeight: 600}} className="mb-0">Información del documento</p>
            </Div>
            <Div col={12}>
                <hr className="mt-0"/>
            </Div>

            <Div col={6}>
                <InputText
                    label={"Documento"}
                    name={"Documento"}
                    value={modalDataToCreate[KEYS.NombreFlujoDocumento]}
                    sectionName={SECTION_NAME}
                    direction="column"
                    isDisabled={true}
                />
            </Div>

            <Div col={3}>
                <InputDate
                    label={"Fecha de inicio"}
                    name={KEYS.FechaInicio}
                    value={modalDataToCreate[KEYS.FechaInicio]}
                    sectionName={SECTION_NAME}
                    isDisabled={true}
                    isRequired={false}
                    direction="column"
                />
            </Div>

            <Div col={3}>
                <InputDate
                    label={"Fecha de fin"}
                    value={modalDataToCreate[KEYS.FechaFin]}
                    sectionName={SECTION_NAME}
                    isDisabled={true}
                    isRequired={false}
                    direction="column"
                />
            </Div>

            <Div col={12}>
                <InputTextArea
                    label="Instrucciones"
                    value={modalDataToCreate[KEYS.Instrucciones]}
                    isDisabled={true}
                    isRequired={false}
                    placeholder={" "}
                    direction="column"
                    sectionName={SECTION_NAME}
                />
            </Div>
















            {modalDataAlreadyCreated?.Observacion &&
                <Div col={12} additionalClass={"mb-2"}>
                    <InputTextArea label="Observación" isDisabled={true} value={modalDataAlreadyCreated?.Observacion} direction="column"/>
                </Div>
            }

            <Div col={4} additionalClass="d-flex justify-content-center align-items-center mb-1">
                <a className="btn generic-button-buscador"  target="_blank" href={modalDataToCreate[KEYS.ProcedimientoUrl] ?? ""}>
                    Mira aquí el procedimiento
                </a>
            </Div>

            {modalDataAlreadyCreated?.PuedeEnviarOrCompletar === false && modalDataAlreadyCreated[KEYS.FlujoDocumentoEmpleadoArchivoUrl] !== "" &&
                <div>
                    <Div col={12} additionalClass="">
                        <a className="btn generic-button-buscador"  target="_blank" href={modalDataAlreadyCreated[KEYS.FlujoDocumentoEmpleadoArchivoUrl] ?? ""}>
                            Descargar Documento Firmado
                        </a>
                    </Div>
                </div>
            }

            {modalDataAlreadyCreated?.PuedeEnviarOrCompletar === true &&
                <>

                    <Div col={12} additionalClass="mt-2">
                        <UploadFileStyleDiv className="d-flex align-items-center justify-content-center">
                            <div className="column-step1 ">
                                <div className="step-number">1</div>
                                <div className="button">
                                    <button className="btn btn-primary generic-button-ficha" disabled={descargandoArchivo}
                                            onClick={(e) => {
                                                descargar(e, row)
                                            }}> {descargandoArchivo ? 'Descargando...' : 'Descargar'}
                                    </button>
                                </div>
                            </div>
                            <div className="column-step2">
                                <div className="step-number">2</div>
                                <InputUploadFile
                                    name={KEYS.FlujoDocumentoEmpleadoArchivoFileViewModel}
                                    uploadFile={formValues[KEYS.FlujoDocumentoEmpleadoArchivoFileViewModel]}
                                    setUploadFile={(res) =>
                                        setFormValues({...formValues, [KEYS.FlujoDocumentoEmpleadoArchivoFileViewModel]: res})
                                    }
                                    sectionName={SECTION_NAME}
                                    setIsUploading={setDisableSubmitButton}
                                    validExtensions={["pdf"]}
                                    isRequired={true}
                                    colLabel={0}
                                    colInput={12}
                                />
                            </div>
                        </UploadFileStyleDiv>
                    </Div>

                </>

            }


            <Div col={12} additionalClass="mt-2 d-flex justify-content-end">
                {modalDataAlreadyCreated.PuedeObservar === true &&
                <button
                    type="button"
                    className="btn btn-primary generic-button-ficha-modal generic-button-hover-rojo mr-1"
                    onClick={() => setModalEnabled({ isEnable: true, component: ObservarFlujoDocumentoEmpleado, data: { toggleMainModal, idFlujoDocumentoEmpleado: row.IdFlujoDocumentoEmpleado } })}
                >
                    Observar
                </button>
                }
                {modalDataAlreadyCreated.PuedeAprobar === true &&
                    <button
                    type="button"
                    className="btn btn-primary generic-button-ficha-modal  generic-button-hover-verde  mr-1"
                    onClick={() => {handleAprobar()}}
                >
                    Aprobar
                </button>
                }
                {modalDataAlreadyCreated.PuedeEnviarOrCompletar === true &&
                    <button
                    type="button"
                    className="btn btn-primary generic-button-ficha-modal generic-button-hover-azul"
                    onClick={() => {handleEnviar()}}
                >
                    Enviar
                </button>
                }
            </Div>




        </>
    )
}

export default FlujoDocumentoEmpleado;